import { Loader } from "@googlemaps/js-api-loader"

let map;

export function initMap() {
    const mapElement = document.getElementById("map")
    if (!mapElement ) {
        return
    }
    if (map) {
        return
    }
    const loader = new Loader({
        apiKey: "AIzaSyC4EFdPtyiZrRk0A5ZI0r2V0xkgsxOpOWo",
        version: "weekly",
        libraries: ["marker"],
    });
    loader.load().then(async () => {
        const position = { lat: 25.169812309938727, lng: 55.24179670498412 };
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        map = new Map(mapElement, {
          center: position,
          zoom: 16,
          mapId: "IDa16d3bbd5b5d62c4",
        });

        const marker = new AdvancedMarkerElement({
            map: map,
            position: position,
            title: "Dae Rental Cars",
        });
    });      
}